import Vue from 'vue'
import Vuex from 'vuex'
import state from './state.js'
import actions from './actions.js'
import mutations from './mutations.js'
import user from './modules/user'
import portraitBayonet from './modules/portraitBayonet'


Vue.use(Vuex)

export default new Vuex.Store({
  state,
  actions,
  mutations,
  modules: {
    user,
    portraitBayonet
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js